import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbComponentStatus,
  NbDialogRef,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import Quiz from "../../models/quiz.model";
import { QuizContentService } from "../../services/quiz-content.service";

@Component({
  selector: "ngx-dialog-test-quiz",
  templateUrl: "dialog-test-quiz.component.html",
  styleUrls: ["dialog-test-quiz.component.scss"],
})
export class DialogTestQuizComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() quizId?: string;
  @Output() onFinished?: EventEmitter<any> = new EventEmitter();

  quiz: Quiz = new Quiz();

  submitted = false;
  loading = false;
  lastQuiz = false;

  status() {
    if (this.loading) return "warning";

    if (!this.quiz.submitted) {
      return "info";
    } else {
      if (this.quiz.isCorrect) {
        return "success";
      } else {
        return "danger";
      }
    }
  }

  constructor(
    protected ref: NbDialogRef<DialogTestQuizComponent>,
    private quizService: QuizContentService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    this.getQuiz(this.quizId);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getQuiz(id) {
    this.loading = true;
    this.quizService
      .loadQuestion(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.loading = false;
        if (data) {
          this.quiz = data;
          this.quiz.id = id;
        }
      });
  }

  submit() {
    this.loading = true;
    this.submitted = true;
    this.quiz.submitted = true;

    this.quizService
      .submitAnswer(this.quiz)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.quiz.isCorrect = data.isCorrect;
        this.quiz.resultAnswers = data.resultAnswers;
        this.quiz.valueAnswer = data.valueAnswer;
        this.quiz.explain = data.explain;

        this.showAnswer();

        this.loading = false;
        this.submitted = false;
      });
  }

  reload() {
    this.getQuiz(this.quizId);
  }

  close() {
    this.ref.close();
  }

  private showAnswer() {
    if (this.quiz.isCorrect) {
      this.quiz.title = "Bạn đã trả lời đúng. Chúc mừng bạn!";
      this.showToast("success", "Trả lời đúng", "Xin chúc mừng!");
    } else {
      this.quiz.title = "Bạn đã trả lời sai. Xin vui lòng thử lại!";
      this.showToast("danger", "Trả lời sai", "Xin vui lòng thử lại!");
    }
    //Show correct answers
    this.quiz.answers.forEach((item) => {
      const objF = this.quiz.resultAnswers.find((el) => el == item.value);
      item.isCorrect = objF ? true : false;
    });
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
